import { Application } from 'stimulus'
import CheckboxListController from "./controllers/checkbox_list_controller";
import TiltController from "./controllers/tilt_controller";
import ScoreboardController from "./controllers/scoreboard_controller";
import GameController from "./controllers/game_controller";

const application = Application.start()
application.register('checkbox-list', CheckboxListController)
application.register('tilt', TiltController)
application.register('scoreboard', ScoreboardController)
application.register('game', GameController)
